<template>
  <div class="component-body">
    <span class="title">危废数据</span>
    <div class="component-content">
      <el-tabs v-model="tabsName" class="el-tabs">
        <el-tab-pane label="视图" name="视图">
          <charts />
        </el-tab-pane>
        <el-tab-pane label="列表" name="列表" :lazy="true">
          <list />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import list from "./list.vue";
import charts from "./charts.vue";
export default {
  components: { list, charts },
  data() {
    return {
      tabsName: "视图",
    };
  },
  methods: {},

  mounted() {},
};
</script>

<style lang="scss" scoped>
.component-body {
  height: 100%;

  .title {
    font-size: 18px;
    font-weight: bold;
    border-left: 8px solid #1890ff;
    padding-left: 12px;
  }

  .date-select {
    padding-bottom: 5px;
  }

  .component-content {
    height: calc(100% - 21px);
    padding-top: 5px;
    padding: 5px 15px;

    .el-tabs {
      width: 100%;
      height: 100%;

      /deep/.el-tabs__content {
        height: calc(100% - 55px);

        .el-tab-pane {
          height: 100%;
        }
      }
    }
  }
}
</style>
